import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, AlertCircle, Loader2 } from 'lucide-react';
import api from '../services/api';

export default function FollowUpResponse() {
  const { token, response } = useParams<{ token: string; response: string }>();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const [responseType, setResponseType] = useState<string | null>(null);

  useEffect(() => {
    if (!token || !response) {
      setStatus('error');
      setMessage('Lien invalide.');
      return;
    }

    const sendResponse = async () => {
      try {
        const res = await api.get(`/prelaunch/follow-up/${token}/${response}`);
        setStatus('success');
        setMessage(res.data.message);
        setResponseType(res.data.response);
      } catch (err: unknown) {
        setStatus('error');
        const error = err as { response?: { data?: { message?: string } } };
        setMessage(error.response?.data?.message || 'Une erreur est survenue.');
      }
    };

    sendResponse();
  }, [token, response]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center space-y-6">
        <div className="flex justify-center">
          <div className="px-6 py-3 rounded-full flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-600">
            <span className="text-white text-2xl font-bold">Splinity</span>
          </div>
        </div>

        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 text-primary-500 animate-spin mx-auto" />
            <p className="text-gray-600">Traitement en cours...</p>
          </>
        )}

        {status === 'success' && responseType === 'interested' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto" />
            <h1 className="text-2xl font-bold text-gray-900">Merci !</h1>
            <p className="text-gray-600">{message}</p>
          </>
        )}

        {status === 'success' && responseType === 'not_interested' && (
          <>
            <XCircle className="w-16 h-16 text-gray-400 mx-auto" />
            <h1 className="text-2xl font-bold text-gray-900">Compris</h1>
            <p className="text-gray-600">{message}</p>
          </>
        )}

        {status === 'error' && (
          <>
            <AlertCircle className="w-16 h-16 text-red-500 mx-auto" />
            <h1 className="text-2xl font-bold text-gray-900">Erreur</h1>
            <p className="text-gray-600">{message}</p>
          </>
        )}

        <Link
          to="/"
          className="inline-block mt-4 text-primary-600 hover:text-primary-700 font-medium"
        >
          Retour a l'accueil
        </Link>
      </div>
    </div>
  );
}
